import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CardPlus icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CardPlus } from '@sravni/design-system-icons'
 *
 * <CardPlus />
 * ```
 */
var CardPlus = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CardPlus", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.143 15H3.572a2.143 2.143 0 0 1-2.143-2.143V5.714c0-1.183.959-2.143 2.143-2.143H15c1.184 0 2.143.96 2.143 2.143V10M1.429 6.428h15.714", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M4.643 11.428h3.571", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "square", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M15.715 12.5v2.143M16.785 13.571h-2.142", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "square" }),
    React.createElement("path", { d: "M15.714 17.857a4.286 4.286 0 1 0 0-8.571 4.286 4.286 0 0 0 0 8.571Z", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }))); });

export { CardPlus };
//# sourceMappingURL=CardPlus.js.map
